import JobListingJobCard from '@/modules/JobListingJobCardList/components/JobListingJobCard/JobListingJobCard';
import JobListingRegisterCtaBanner from '@/modules/JobListingRegisterCtaBanner';
import { IJobDetail, JobSearchWebCriteria } from '@/types/jobs';
import { getRandomIntInclusive } from '@/utils/getRandomInt';
import React from 'react';

export type JobCardListProps =
  | {
      jobs: IJobDetail[];
      suppressCTABanner: true;
      isHighlighted?: boolean;
      ctaPosition?: 'bottom';
    }
  | {
      jobs: IJobDetail[];
      suppressCTABanner?: false;
      isUserLoggedIn: boolean;
      query: JobSearchWebCriteria; // the criteria for the search that resulted in this banner being shown
      isHighlighted?: boolean;
      ctaPosition?: 'bottom' | 'random';
    };

const JobListingJobCardList = (props: JobCardListProps) => {
  const { jobs, suppressCTABanner } = props;
  // get a random job card index from 1 to 5
  // which would allow insert the banner to a position from 3 to 7
  const randomIndex = getRandomIntInclusive(1, 5);
  // make sure the banner is always shown when the job list is shorter than random index
  const bannerIndex =
    jobs.length - 1 < randomIndex || props?.ctaPosition === 'bottom'
      ? jobs.length - 1
      : randomIndex;

  return (
    <>
      {jobs.map((job, index) => {
        return (
          <div key={job.id}>
            <JobListingJobCard job={job} isHighlighted={props.isHighlighted ?? false} />
            {index === bannerIndex &&
              (suppressCTABanner ? (
                <JobListingRegisterCtaBanner suppressCTABanner={true} />
              ) : (
                <JobListingRegisterCtaBanner
                  isUserLoggedIn={props.isUserLoggedIn}
                  position={bannerIndex + 2}
                  query={props.query}
                />
              ))}
          </div>
        );
      })}
    </>
  );
};

export default JobListingJobCardList;
